import { memo } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { useSubscriptionStats } from '../../hooks/subscriptions';

const COLORS = ['#6366F1', '#8B5CF6', '#3B82F6', '#10B981', '#F59E0B', '#EF4444'];

export const ModuleAdoptionChart = memo(() => {
  const { data: stats, isLoading } = useSubscriptionStats();

  if (isLoading) {
    return (
      <Card>
        <CardContent>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
            <CircularProgress />
          </Box>
        </CardContent>
      </Card>
    );
  }

  const moduleData = stats?.moduleAdoption || [];

  // Sort by count descending
  const sortedData = [...moduleData].sort((a, b) => b.count - a.count);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Module Adoption
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Number of organizations using each module
        </Typography>

        <Box sx={{ width: '100%', height: 350, mt: 2 }}>
          {sortedData.length === 0 ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Typography variant="body2" color="text.secondary">
                No module adoption data available
              </Typography>
            </Box>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={sortedData}
                layout="vertical"
                margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis type="number" stroke="#666" style={{ fontSize: '12px' }} />
                <YAxis
                  type="category"
                  dataKey="moduleName"
                  stroke="#666"
                  style={{ fontSize: '12px' }}
                  width={90}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                  formatter={(value: number, name: string, props: any) => [
                    `${value} orgs (${props.payload.percentage.toFixed(1)}%)`,
                    'Adoption',
                  ]}
                />
                <Bar dataKey="count" radius={[0, 4, 4, 0]}>
                  {sortedData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          )}
        </Box>
      </CardContent>
    </Card>
  );
});
